import React from 'react';

const Page11MonthlyInvoice = ({ 
  invoiceClarity,
  setInvoiceClarity,
  invoiceFeedback,
  setInvoiceFeedback,
  handlePrevious,
  handleNext 
}) => {
  // Add logging function
  const handleNextWithLogging = () => {
    console.log("Page 11 - Selected invoiceClarity:", invoiceClarity);
    console.log("Page 11 - Feedback provided:", invoiceFeedback);
    handleNext();
  };

  return (
    <>
      <div className="questions-grid">
        <div className="question-item full-width">
          <label>Is the monthly invoice clear and understandable to you?</label>
          <div className="rating-options">
            {['Yes', 'No'].map((option) => (
              <label 
                key={option}
                className={`rating-box ${invoiceClarity === option.toLowerCase() ? 'selected' : ''}`}
              >
                <input
                  type="radio"
                  name="invoice"
                  value={option.toLowerCase()}
                  checked={invoiceClarity === option.toLowerCase()}
                  onChange={(e) => {
                    console.log("Setting invoiceClarity to:", e.target.value);
                    setInvoiceClarity(e.target.value);
                  }}
                />
                <span>{option}</span>
              </label>
            ))}
          </div>
        </div>
        
        {/* Conditionally show feedback field if "No" is selected */}
        {invoiceClarity === 'no' && (
          <div className="question-item full-width">
            <label>How can we help in providing more clarity?</label>
            <textarea
              value={invoiceFeedback}
              onChange={(e) => setInvoiceFeedback(e.target.value)}
              placeholder="Please provide your suggestions here..."
              className="long-answer-input"
            />
          </div>
        )}
      </div>
      <div className="button-group">
        <button className="nav-button" onClick={handlePrevious}>Previous</button>
        <button 
          className="nav-button" 
          onClick={handleNextWithLogging}
          disabled={!invoiceClarity || (invoiceClarity === 'no' && !invoiceFeedback.trim())}
        >
          Next
        </button>
      </div>
    </>
  );
};

export default Page11MonthlyInvoice;
